import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OfflineService } from 'src/app/offline/offline.service';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { NotificationService } from '../services/notifications.service';
import { SearchResponseIO } from 'src/app/models/search-responseIO';
import { SearchResult } from 'src/app/models/common/search-result';
import { MoreOption } from 'src/app/models/common/more-option';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { PolicyDetailsService } from 'src/app/policydetails/services/policydetails.service';

@Component({
  selector: '',
  template: '',
})
export class LapsedPoliciesHandler extends BaseSearchComponent<NotificationService> implements OnInit {
  public searchName: string;
  isAdvanceSearchDisplayed: boolean;

  constructor(
    public service: NotificationService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, router, headerService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.searchName = 'SearchLapsedPolicies';
    this.isAdvanceSearchDisplayed = true;
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: 'Search',
      },
    ];
  }

  protected getMoreOptionList(): any[] {
    return [
      {
        id: 'Edit',
        link: '/search-lapsed-policies',
      },
      {
        id: 'Delete',
        link: '/search-lapsed-policies',
      },
      {
        id: 'Audit',
        link: '/search-lapsed-policies',
      },
      {
        id: 'Close',
        link: '/search-lapsed-policies',
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = 'Lapsed Policies';
    return header;
  }

  Edit_click(optionDetails: { button_id; link; ref_id }) {
    let link: string;
    link = optionDetails.link.toString().replace(':id', optionDetails.ref_id);
    this.router.navigate([link]);
  }

  Audit_click(buttonClicked: { button_id: string; link: string; ref_id }) {
    this.service.id = buttonClicked.ref_id;
    setTimeout(() => {
      //this.service.isAuditButtonClicked = true;
    }, 10);
  }
}
